import Constants from './Constants';
import { ThemeProvider, createTheme } from '@mui/material/styles';

export const voTheme = createTheme({
  palette: {
    primary: { main: '#00bcd4', contrastText: '#ffffff' },
    secondary: { main: '#bdbdbd', contrastText: '#ffffff' },
    active: 'black',
    type: 'light',
  },
  snackbar: {
    error: Constants.COLORS.ERROR,
    success: Constants.COLORS.SUCCESS,
    warning: Constants.COLORS.WARNING,
    info: Constants.COLORS.INFO,
    default: Constants.COLORS.NEUTRAL,
  },
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiListItem: {
      root: {
        background: 'transparent',
        '&$selected': {
          backgroundColor: 'transparent',
          color: '#00bcd4 !important',
        },
      },
    },
    MuiMenuItem: {
      root: {
        background: 'transparent',
        '&$selected': {
          backgroundColor: 'transparent',
          color: '#00bcd4 !important',
        },
      },
    },
    MuiFormHelperText: {
      root: {
        '&$error': {
          position: 'absolute',
          top: '3rem',
        },
      },
    },
    MuiSlider: {
      mark: { height: 8, width: 8, marginTop: -3 },
      markActive: {
        opacity: 1,
        backgroundColor: 'currentColor',
      },
    },
    MuiAutocomplete: {
      option: {
        '&[aria-selected="true"]': {
          backgroundColor: 'transparent',
          color: '#00bcd4 !important',
        },
      },
    },
  },
});
